import moment from "moment";

export const isEdited = (data: any) => {
  return data.editAt ? true : false;
};
export const isEditedComment = (data: any) => {
  return data.updatedAt > data.createdAt ? true : false;
};

export function formatDateTime(dateString: string) {
  const date = new Date(dateString);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}시${minutes}분`;
}

export function formatDateHHMM(dateString: string) {
  const date = new Date(dateString);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
}
export const handleLastConnection = (value?: string) => {
  if (!value) return "알 수 없음";
  return moment(value).fromNow();
};

export const formatDateToYearMonthDay = (dateString: string) => {
  return moment(dateString).format("YYYY-MM-DD");
};

export const formatDate = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatDateWithDay = (value: string) => {
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
  const week = weekdays[date.getDay()];

  return `${year}.${month}.${day}(${week})`;
};

export const getTodayDate = () => {
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getYearList = (is24?: boolean) => {
  const currentYear = new Date().getFullYear();
  const startYear = is24 ? 2024 : 2025;

  let list = [];
  for (let year = startYear; year <= currentYear; year++) {
    list.push(year);
  }

  return list;
};
